;'use strict';
$(document).ready(function () {
    const $body = $('body');
    const $mobileMenuBtn = $('.mm__open-menu');
    const $mobileToggleNav = $('.mobile--menu');
    const $aislesToggleNav = $('.aisles--menu');

    const $navCoreLink = $('.container__bottom a, .container__bottom button');
    $navCoreLink.each(function () {
        let $this = $(this);
        let isCoreLink = $this.data('core-link');
        if (isCoreLink) {
            $this.closest('li').addClass('nav--core-link');
        }
    });

    const closeMenuNav = function (mobileMenu) {
        $body.removeClass('overflow-hidden');
        $('.aisles--btn').attr('aria-expanded', false);
        $('.toggleBtn').attr('aria-expanded', false);
        $mobileMenuBtn.attr('aria-expanded', false).removeClass('active');
        $('.menu-toggle-nav.active').removeClass('active').addClass('inactive').prop('inert', true);
        $('.nav-overlay').remove();
        $('.sub-nav-head').removeClass('two-col');
        $('.aisles--subNav--lev2').empty();
        $('.aisles--subNav--lev3').empty();
        $('.active--nav').removeClass('active--nav');
        $('.btn-display-aisle').attr('aria-expanded', false);
        $('.hide-overflow').removeClass('hide-overflow');
        $aislesToggleNav.removeClass('active');
        $aislesToggleNav.addClass('inactive').prop('inert', true);
        if (mobileMenu != false) {
            $mobileToggleNav.removeClass('active');
            $mobileToggleNav.addClass('inactive').prop('inert', true);
        }
    }

    const manageCloseNavOverlay = function () {
        $('.nav-overlay').on('click', function (e) {
            if (e.target === this) {
                closeMenuNav();
            }
        });
    }

    const showToggleMenu = function (elm, toggleType, toggleTab, isSubMenu) {

        if (typeof inInternalServerErrorPage !== 'undefined' && inInternalServerErrorPage) {
            return;
        }

        $('.nav-overlay').remove();
        $body.addClass('overflow-hidden');
        $mobileMenuBtn.addClass('active').attr('aria-expanded', true);

        if (isSubMenu) {
            $('.toggle-nav--sub.active .toggleBtn').attr('aria-expanded', false);
            let $subLevelActive = $('.second-level-sub-nav.active');
            if ($subLevelActive.length) {
                $subLevelActive.addClass('inactive').removeClass('active');
            }


            toggleTab.addClass('second-level-sub-nav');
            toggleTab.find('.submenu-back-btn').addClass('close-sub-nav');
        } else {
            let subNavBtn = toggleTab.find('.toggleBtn');
            subNavBtn.each(function() {
               let $this = $(this);
               let toggleBtnTarget = $this.attr('data-open-menu-pannel');
               let targetPannel = $('.menu-toggle-nav[data-target-node-folder=' + toggleBtnTarget + ']');
                targetPannel.addClass('second-level-sub-nav');
            });
        }

        if (toggleType == 'subNavigation' || toggleType == 'aisles') {
            elm.attr('aria-expanded', true);
            $mobileToggleNav.addClass('active');
            $mobileToggleNav.removeClass('inactive');
            toggleTab.append('<span class="nav-overlay" />');
        } else {
            $mobileToggleNav.append('<span class="nav-overlay" />');
        }

        if (window.innerWidth >= 1200) {
            $('.navigation__btn--close').focus();
            let $lastAisleElm = $('.aisles--menu').find('li').last();
            headerMenuAisle.aisleMenuFocusTrap($lastAisleElm);
        }

        toggleTab.addClass('active');
        toggleTab.removeClass('inactive');
        toggleTab.prop('inert', false);
        manageCloseNavOverlay();
    };

    $('.aisles--btn').click(function () {
        let $this = $(this);
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'aisles', $aislesToggleNav, false);
        } else {
            closeMenuNav();
        }
    });

    $('.link-confirmation').click(function (event) {
        if (!isAuthenticated) {
            loginSidePanel();
            event.preventDefault();
            return false;
        }
    });

    $mobileMenuBtn.click(function () {
        let $this = $(this);
        if ($this.attr('aria-expanded') === 'false') {
            showToggleMenu($this, 'mobileNav', $mobileToggleNav, false);
        } else {
            closeMenuNav();
        }
    });

    $('.header-nav--links .toggleBtn').click(function () {
        let $this = $(this);
        let panelId = $this.data('open-menu-pannel');
        let $panelSelector = $('.menu-toggle-nav[data-target-node-folder=' + panelId + ']');
        let isSubMenu = $this.closest('.toggle-nav--sub').length;
        if ($this.attr('aria-expanded') === 'false' && !isSubMenu) {
            showToggleMenu($this, 'subNavigation', $panelSelector, false);
        } else if ($this.attr('aria-expanded') === 'false' && isSubMenu) {
            showToggleMenu($this, 'subNavigation', $panelSelector, true);
            $this.closest('.nav--container').find('.sub-nav-head').addClass('two-col');
        }
    });

    $('.navigation__btn--close').click(function () {
        closeMenuNav();
    });

    $('.aisles--lvl-1, .submenu-back-btn').click(function () {
        if ($(this).hasClass('close-sub-nav')) {
            let currentSubNavPanel = $(this).closest('.toggle-nav--sub.active');
            let previousTriggerId = currentSubNavPanel.data('target-node-folder');
            currentSubNavPanel.removeClass('active').addClass('inactive').prop('inert', true);
            currentSubNavPanel.find('.nav-overlay').remove();
            $('.toggleBtn[data-open-menu-pannel=' + previousTriggerId + ']').attr('aria-expanded', false);
            $('.toggle-nav--sub.active').append('<span class="nav-overlay" />');
            $('.mobile--menu .toggleBtn').attr('aria-expanded', false);
            manageCloseNavOverlay();
        } else {
            closeMenuNav(true);
            showToggleMenu(false, 'mobileNav', $mobileToggleNav, false);
        }
    });

    $('.aisles--lvl-2').click(function () {
        $('.sub--nav--second').removeClass('active--nav');
        $('.btn-display-aisle').attr('aria-expanded', false);
        $('.sub--nav--first').removeClass('hide-overflow');
    });

});